import React from "react";
import * as styles from "./styles.module.scss";

const maybeEmbedUrl = (url) => {
  try {
    const urlObj = new URL(url);
    if (
      urlObj.hostname === "www.youtube.com" ||
      urlObj.hostname === "youtube.com"
    ) {
      const videoId = urlObj.searchParams.get("v");
      return `https://www.youtube.com/embed/${videoId}`;
    }
    return url;
  } catch {
    return url;
  }
};

const VideoViewer = ({
  url,
  handleLoad,
  handleError,
  title = "Video viewer",
}) => {
  const embedUrl = maybeEmbedUrl(url);
  return (
    <div className="card w-100">
      <div className="card-body">
        <div className={styles.videoContainer}>
          <iframe
            src={embedUrl}
            title={title}
            onLoad={handleLoad}
            onError={handleError}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          />
        </div>
      </div>
    </div>
  );
};

export default VideoViewer;
